import type { QueryClient } from '@tanstack/react-query';
import {
  fetchRatingsOverview,
  RATINGS_OVERVIEW_KEY,
} from 'hooks/reviews/useRatingsOverview';
import {
  fetchReviewedProducts,
  REVIEWED_PRODUCTS_KEY,
} from 'hooks/reviews/useReviewedProducts';
import { fetchGlobals, GLOBALS_KEY } from 'hooks/useGlobals';
import { fetchWithSentry } from 'utils/pageTemplates/fetchWithSentry';

export const prefetchCommonData = async (queryClient: QueryClient) => {
  await fetchWithSentry({
    queryClient,
    queryKey: [GLOBALS_KEY],
    queryFn: fetchGlobals,
    tags: {
      template: 'prefetchCommonData',
      query: GLOBALS_KEY,
      api: 'sanity+shopify',
    },
  });

  // Ratings overview for various places including anywhere that uses the Overline component (heroes, banners, etc.)
  await fetchWithSentry({
    queryClient,
    queryKey: [RATINGS_OVERVIEW_KEY],
    queryFn: fetchRatingsOverview,
    tags: {
      template: 'prefetchCommonData',
      query: RATINGS_OVERVIEW_KEY,
      api: 'junip',
    },
  });

  // Reviewed products for product cards in various places including the mega menu
  await fetchWithSentry({
    queryClient,
    queryKey: [REVIEWED_PRODUCTS_KEY],
    queryFn: fetchReviewedProducts,
    tags: {
      template: 'prefetchCommonData',
      query: REVIEWED_PRODUCTS_KEY,
      api: 'junip',
    },
  });
};
